// apps/web/src/offline/OfflineLeadService.js

import {
  STORES,
  createLocalId,
  dbGet,
  dbGetAllByIndex,
  dbPut,
} from './db'

const LEAD_SYNC_STATUS = {
  PENDING_SYNC: 'PENDING_SYNC',
  SYNCED: 'SYNCED',
  ERROR: 'ERROR',
}

const createOfflineLead = async ({
  game,
  leadForm,
  values,
  consentLgpd,
}) => {
  if (!game?.id) {
    throw new Error(
      'GAME_ID_REQUIRED',
    )
  }

  if (!leadForm?.id) {
    throw new Error(
      'LEAD_FORM_ID_REQUIRED',
    )
  }

  const localId =
    createLocalId('lead')

  const clientOperationId =
    createLocalId('lead-operation')

  const now =
    new Date().toISOString()

  const record = {
    localId,

    clientOperationId,

    serverLeadId:
      null,

    gameId:
      game.id,

    gameSlug:
      game.slug || null,

    eventId:
      game.eventId ||
      game.event?.id ||
      leadForm.eventId ||
      null,

    formId:
      leadForm.id,

    values:
      values || {},

    consentLgpd:
      Boolean(consentLgpd),

    syncStatus:
      LEAD_SYNC_STATUS
        .PENDING_SYNC,

    syncAttempts:
      0,

    lastSyncAttemptAt:
      null,

    lastSyncError:
      null,

    createdAt:
      now,

    updatedAt:
      now,
  }

  await dbPut(
    STORES.LEADS,
    record,
  )

  console.log(
    '[OFFLINE LEAD] Lead salvo:',
    record,
  )

  return record
}

const getLead = async (
  localId,
) => {
  if (!localId) {
    return null
  }

  return dbGet(
    STORES.LEADS,
    localId,
  )
}

const getPendingLeads =
  async () => {
    return dbGetAllByIndex(
      STORES.LEADS,
      'syncStatus',
      LEAD_SYNC_STATUS
        .PENDING_SYNC,
    )
  }

const markLeadSynced = async (
  lead,
  serverLeadId,
) => {
  const updated = {
    ...lead,

    serverLeadId:
      serverLeadId || null,

    syncStatus:
      LEAD_SYNC_STATUS.SYNCED,

    lastSyncError:
      null,

    updatedAt:
      new Date().toISOString(),
  }

  await dbPut(
    STORES.LEADS,
    updated,
  )

  return updated
}

const markLeadPending = async (
  lead,
  error = null,
) => {
  const updated = {
    ...lead,

    syncStatus:
      LEAD_SYNC_STATUS
        .PENDING_SYNC,

    syncAttempts:
      Number(
        lead.syncAttempts || 0,
      ) + 1,

    lastSyncAttemptAt:
      new Date().toISOString(),

    lastSyncError:
      error
        ? String(
            error?.message ||
            error,
          )
        : null,

    updatedAt:
      new Date().toISOString(),
  }

  await dbPut(
    STORES.LEADS,
    updated,
  )

  return updated
}

const markLeadError = async (
  lead,
  error,
) => {
  const updated = {
    ...lead,

    syncStatus:
      LEAD_SYNC_STATUS.ERROR,

    syncAttempts:
      Number(
        lead.syncAttempts || 0,
      ) + 1,

    lastSyncAttemptAt:
      new Date().toISOString(),

    lastSyncError:
      String(
        error?.message ||
        error ||
        'Erro desconhecido',
      ),

    updatedAt:
      new Date().toISOString(),
  }

  await dbPut(
    STORES.LEADS,
    updated,
  )

  return updated
}

const OfflineLeadService = {
  createOfflineLead,

  getLead,
  getPendingLeads,

  markLeadSynced,
  markLeadPending,
  markLeadError,
}

export {
  LEAD_SYNC_STATUS,
}

export default OfflineLeadService